module.exports = __webpack_public_path__ + "img/dealing_travel.341e33ed.jpg";